import { Flex, Text } from 'ui'

import { useFillRateMetrics } from 'queries/pulse/useFillRateMetrics'
import { usePulseContext } from '../../context/PulseProvider'
import { MetricBox } from '../MetricBox'
import { formatNumber, formatPercentage } from 'lib/string'

export function FillRateMetrics() {
  const {
    state: { filters },
  } = usePulseContext()

  const { data, isLoading } = useFillRateMetrics(filters)

  return (
    <Flex flexDirection="column" gap={3}>
      <Text fontSize={3} fontWeight="500">
        Fill Metrics
      </Text>
      <Flex
        flexWrap={'wrap'}
        flexDirection={['column', 'row', 'row']}
        justifyContent="space-between"
        gap={2}
      >
        <MetricBox
          title="Average Fill Rate"
          isLoading={isLoading}
          value={formatPercentage(data?.avg_fill_rate ?? 0, 2)}
        />
        <MetricBox
          title="Total Requested Shifts"
          isLoading={isLoading}
          value={formatNumber(data?.total_requested_shifts ?? 0)}
        >
          {!!data?.total_requested_shifts_forecast && (
            <Text fontSize="2" mb={1}>
              Upcoming: {formatNumber(data.total_requested_shifts_forecast)}
            </Text>
          )}
        </MetricBox>
        <MetricBox
          title="Total Filled Shifts"
          isLoading={isLoading}
          value={formatNumber(data?.total_filled_shifts ?? 0)}
        />
        <MetricBox
          title="# of Hours Worked"
          isLoading={isLoading}
          value={formatNumber(data?.total_hours_worked ?? 0)}
        />
      </Flex>
    </Flex>
  )
}
